import React, { useCallback } from 'react'
import { useMutation } from 'react-query'
import { uploadImage, editImage, deleteImage } from '@app-core/api'
import ImageUpload from './ImageUpload'
import { handleImageFile } from '../_shared/handleImageFile'
import { useArticleContext } from '../_core'
import { useTranslation } from 'react-i18next'
import Callout from '@components/DesignSystem/Callout'
import { styled, theme } from 'twin.macro'

const ImageInputContainer = () => {
  const { t } = useTranslation('editor')

  const [uploadImageMutate] = useMutation(uploadImage)
  const [editImageMutate] = useMutation(editImage)
  const [deleteImageMutate] = useMutation(deleteImage)
  const {
    dispatch,
    ActionType,
    PublishButtonStatusType,
    articleState: {
      publish: { timestamp, warnings },
    },
  } = useArticleContext()
  const handleImageStart = useCallback(
    () =>
      dispatch({
        type: ActionType.PUBLISH_STATUS_CHANGED,
        value: PublishButtonStatusType.DISABLED,
        target: 'upload_cover_image',
      }),
    [dispatch, ActionType, PublishButtonStatusType],
  )
  const handleImageEnd = useCallback(
    () =>
      dispatch({ type: ActionType.PUBLISH_STATUS_CHANGED, value: PublishButtonStatusType.IDLE }),
    [dispatch, ActionType, PublishButtonStatusType],
  )

  return (
    <>
      <ImageUpload
        handleImageFile={handleImageFile}
        onImageUpload={uploadImageMutate}
        onImageEdit={editImageMutate}
        onImageDelete={deleteImageMutate}
        onImageUploadStart={handleImageStart}
        onImageUploadEnd={handleImageEnd}
      />
      {warnings?.imageRequired && (
        <StyledCallout
          key={timestamp}
          title={t('warnings.imageRequired.title')}
          message={t('warnings.imageRequired.message')}
        />
      )}
    </>
  )
}

export default React.memo(ImageInputContainer)

const StyledCallout = styled(Callout)`
  margin: 16px 16px 0;
  @media (min-width: ${theme`screens.md`}) {
    margin: 16px 0 0;
  }
`
